module.exports = __webpack_public_path__ + "static/media/03.0.High and Low pitch IndianDrum Chande.98d62f22.JPG";